import Hero from './sections/Hero';
import TeacherHowItWorks from './sections/HowItWorks';
import Abilities from './sections/Abilities';

const InteractiveTeacher = () => {
  return (
    <>
      <Hero />
      <TeacherHowItWorks />
      <Abilities />
    </>
  );
};

export default InteractiveTeacher;
